import { useRef, useEffect, useCallback } from 'react';

const throttle = (callback, limit) => {
  let waiting = false;

  // eslint-disable-next-line func-names
  return function (...args) {
    if (!waiting) {
      callback.apply(this, args);

      waiting = true;

      setTimeout(() => {
        waiting = false;
      }, limit);
    }
  };
};

export default (callback, delay) => {
  const cbRef = useRef(callback);

  useEffect(() => {
    cbRef.current = callback;
  });

  return useCallback(
    throttle((...args) => cbRef.current(...args), delay),
    [delay],
  );
};
